import { useEffect, useState } from "react"

import { Spinner } from "@/components/ui/spinner"
import { testChatAgentPath } from "@/routes"

// IMP-530: the website-chat Test tab — the real widget, framed from our own
// app, running the job's saved configuration. Before framing, one readiness
// call brings up the Retell chat backing for agents that were seeded rather
// than set up through the wizard, and syncs the saved config so the
// conversation is the production one.

function csrfToken(): string {
  return (
    document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content") ?? ""
  )
}

export function ChatTestPanel({ agentUid }: { agentUid: string }) {
  const [widgetPath, setWidgetPath] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    fetch(testChatAgentPath(agentUid), {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": csrfToken(),
      },
      credentials: "same-origin",
    })
      .then(async (response) => {
        const data = (await response.json()) as {
          widget_path?: string
          error?: string
        }
        if (cancelled) return
        if (response.ok && data.widget_path) setWidgetPath(data.widget_path)
        else setError(data.error ?? "Couldn't start the chat test.")
      })
      .catch(() => {
        if (!cancelled) setError("Couldn't start the chat test.")
      })
    return () => {
      cancelled = true
    }
  }, [agentUid])

  if (error) {
    return <p className="text-destructive text-sm">{error}</p>
  }

  return (
    <div className="space-y-3">
      <p className="text-muted-foreground text-sm">
        This is your live chat, exactly as visitors get it. Say hello.
      </p>
      <div className="bg-muted/30 relative h-[480px] overflow-hidden rounded-lg border">
        {widgetPath ? (
          <iframe
            src={widgetPath}
            title="Chat test"
            className="h-full w-full"
            allow="clipboard-write"
          />
        ) : (
          <div className="flex h-full items-center justify-center">
            <Spinner className="size-4" />
          </div>
        )}
      </div>
    </div>
  )
}
